import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { H4 } from '@ui/blocks/Heading'
import { Text } from '@ui/blocks/Text'
import { Image } from '@ui/blocks/Image'
import { Container } from '@ui/blocks/Container'
import ZipCodeForm from '@ui/business-components/ZipCodeForm/ZipCodeForm'
import Menu from '@ui/business-components/Footer/Menu'

export const StyledFooter = styled.footer`
  background-color: ${({ theme }) => `${theme.global.colors.elemyGreen}`};
`

export const FooterTop = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 8.8rem 0 5.6rem;
  box-sizing: border-box;
  border-bottom: 1px solid ${({ theme }) => `${theme.global.colors.eden}`};

  @media ${({ theme }) => theme.device.mobileL} {
    padding: 4.8rem 0 3.2rem;
    margin: 0;
  }
`

export const LogoContainer = styled.div`
  flex-basis: 19%;

  @media ${({ theme }) => theme.device.laptopL} {
    flex-basis: 14%;
  }

  @media ${({ theme }) => theme.device.laptop} {
    margin-bottom: 1rem;
    flex-basis: 100%;
    text-align: center;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    margin-bottom: 0;
  }
`

export const SocialLinks = styled.ul`
  display: none;
  align-items: center;
  margin-left: 6.4rem;

  @media ${({ theme }) => theme.device.laptop} {
    order: 1;
    flex-basis: 50%;
    display: flex;
    justify-content: flex-end;
    margin-left: 0;
  }

  @media ${({ theme }) => theme.device.tablet} {
    order: 0;
    margin-left: 0;
    margin-bottom: 2.4rem;
    flex-basis: 100%;
    justify-content: center;
  }
`

export const SocialItem = styled.li`
  font-size: 0;

  :not(:last-child) {
    margin-right: 3.2rem;
  }
`

export const SocialLink = styled.a`
  display: inline-block;
  font-size: 0;
`

export const SocialIcon = styled(Image)`
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
`

export const FormContainer = styled.div`
  flex-basis: 25%;

  @media ${({ theme }) => theme.device.laptopL} {
    flex-basis: 26%;
  }

  @media ${({ theme }) => theme.device.laptop} {
    margin-bottom: 7rem;
    flex-basis: 100%;
    order: 1;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    margin-bottom: 3.2rem;
  }

  ${SocialLinks} {
    display: flex;
    align-items: center;
    margin-top: 4rem;
    margin-left: 0;

    @media ${({ theme }) => theme.device.laptop} {
      display: none;
    }
  }
`

export const FormHeading = styled(H4)`
  margin-bottom: 3.2rem;
  font-weight: 400;
  font-style: normal;
  line-height: 4rem;
  color: ${({ theme }) => `${theme.global.colors.white}`};

  @media ${({ theme }) => theme.device.laptop} {
    text-align: center;
  }

  @media ${({ theme }) => theme.device.tablet} {
    line-height: 4rem;
  }
`

export const StyledZipCodeForm = styled(ZipCodeForm)`
  .zip-code-button {
    margin-right: 0;
  }

  .zip-code-input {
    @media ${({ theme }) => theme.device.laptop} {
      margin-right: auto;
      max-width: 20.3rem;
    }

    @media ${({ theme }) => theme.device.tablet} {
      max-width: 100%;
    }
  }

  .zip-code-input input {
    background-color: ${({ theme }) => theme.global.colors.blueStone};
    border: 1px solid ${({ theme }) => theme.global.colors.blueStone};
  }

  @media ${({ theme }) => theme.device.laptop} {
    margin: 0 auto;
    max-width: 36.7rem;
  }

  @media ${({ theme }) => theme.device.laptopL} {
    flex-basis: 26%;
  }

  @media ${({ theme }) => theme.device.laptop} {
    flex-basis: 100%;
    order: 1;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    max-width: 100%;
  }
`

export const StyledMenu = styled(Menu)`
  flex-basis: 56%;

  @media ${({ theme }) => theme.device.laptopL} {
    flex-basis: 56%;
  }

  @media ${({ theme }) => theme.device.laptop} {
    flex-basis: 100%;
    order: 2;
  }
`

export const FooterBottom = styled.div`
  display: flex;
  padding: 3.2rem 0 3.6rem;

  @media ${({ theme }) => theme.device.laptop} {
    flex-wrap: wrap;
  }

  @media ${({ theme }) => theme.device.tablet} {
    flex-direction: column;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    padding: 3.2rem 0 4.8rem;
    margin: 0;
  }
`

export const Copyright = styled(Text)`
  display: inline-block;
  margin-right: 6.4rem;

  @media ${({ theme }) => theme.device.laptop} {
    flex-basis: 50%;
    margin-right: 0;
  }

  @media ${({ theme }) => theme.device.tablet} {
    order: 1;
    margin-right: 0;
    text-align: center;
  }
`

export const LegalLinks = styled.div`
  display: flex;

  @media ${({ theme }) => theme.device.laptop} {
    order: 2;
    flex-basis: 100%;
    justify-content: space-between;
    margin-top: 1rem;
  }

  @media ${({ theme }) => theme.device.tablet} {
    flex-basis: 100%;
    flex-direction: column;
  }
`

export const LegalLink = styled(Link)`
  display: inline-block;
  font-size: 1.2rem;
  line-height: 3.7rem;
  color: ${({ theme }) => `${theme.global.colors.textLinkGreen}`};

  :not(:last-child) {
    margin-right: 6.4rem;
  }

  :hover {
    color: ${({ theme }) => `${theme.global.colors.white}`};
  }

  :active {
    color: ${({ theme }) => `${theme.global.colors.textLinkGreen}`};
  }

  @media ${({ theme }) => theme.device.laptopL} {
    :not(:last-child) {
      margin-right: 3.9rem;
    }
  }

  @media ${({ theme }) => theme.device.laptop} {
    :not(:last-child) {
      margin-right: 2.4rem;
    }
  }

  @media ${({ theme }) => theme.device.tablet} {
    flex-basis: 100%;
    text-align: center;

    :not(:last-child) {
      margin-right: 0;
    }
  }
`

export const StyledContainer = styled(Container)`
  padding: 0 4.8rem;

  @media ${({ theme }) => theme.device.tablet} {
    padding: 0 4rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    padding: 0 2rem;
  }
`
